import {AfterViewChecked, AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {formArrayNameProvider} from '@angular/forms/src/directives/reactive_directives/form_group_name';
import {T2LoadingService} from '../../../../trip2-theme/components/t2-loading/t2-loading.service';
import {ProvidersService} from '../../../providers/providers.service';
import {ReservationService} from '../../../trip-reservations/reservations.service';
import {ImportTemplateService} from '../../import-template.service';

@Component({
  selector: 'app-define-columns',
  templateUrl: './define-columns.component.html',
  styleUrls: ['./define-columns.component.scss']
})
export class DefineColumnsComponent implements OnInit, OnChanges {

  public form: FormGroup;
  public rules: any[];
  public column: any;
  public empty: any;
  public function: any;
  public sourceSelect: any[];
  public fx: number;
  public col: number;
  public position: number;
  public defaultsData = [];
  @Input() rulesField: any;
  @Input() functionDataSelect: any;
  @Output() showFunctions = new EventEmitter<any>();
  @Output() emitFormDefine = new EventEmitter<any>();

  constructor(
    private fb: FormBuilder,
    protected _loading: T2LoadingService,
    protected _company: ProvidersService,
    protected _tripStatus: ReservationService,
    protected _service: ImportTemplateService
  ) {
    this.sourceSelect = [
      {name: 'functio', description: 'Function', id: 1},
      {name: 'column', description: 'Column', id: 2},
      {name: 'empty', description: 'Empty', id: 3},
      {name: 'default', description: 'Defaults', id: 4}
    ];
  }

  ngOnInit() {
    this.createForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // tslint:disable-next-line:forin
    for (const entry in changes) {
      if (entry === 'functionDataSelect') {
        if (changes['functionDataSelect'].currentValue) {
            this.setFunction(changes['functionDataSelect'].currentValue);
        }
      }
      if (entry === 'rulesField') {
        if (changes['rulesField'].currentValue) {
          this.createForm();
          this.normalizeRules(this.rulesField[0]);
          this.column = this.rulesField[1];
          this.addRules(this.rules);
          this.reviewAndFilterData();
        }
      }
    }
  }

  /**
   * @Metodo getAllUri
   * @description Trae datos segun la uri
   * */
  getAllUri(uri: string, i: number) {
    this._service.getTotalService(uri).subscribe( success => {
      this.generateId(success, i);
    }, error => { });
  }


  /**
   * @Metodo generateId
   * @description Para generar id dinamicamente y cargar defaultsData.
   * */
  generateId(success, i: number) {
    success.forEach(
      row => { row.id = row[this.defaultsData[i].id]; }
    );
    this.defaultsData[i].data = success;
  }


  /**
   * @Metodo setFunction
   * @description Para pasar los valores de functions al form.
   * */
  setFunction(val) {
    const fx = val[0];
    const i = val[1];
    if (this.position === val[1]) {
      this.getRulesForm().at(i).patchValue({
        function: fx
      });
      this.position = undefined;
      this.rules[i].icon = true;
    }
  }

  /**
   * @Metodo createForm
   * @description Para crear el formulario
   * */
  createForm() {
    this.form = this.fb.group({
      rules: this.fb.array([])
    });
    this.selectDataForm();
  }

  /**
   * @Metodo addRules
   * @description Para adicionar control al FormArray
   * */
  addRules(rules) {
    const rul = this.form.controls['rules'] as FormArray;
    rules.forEach(
     (val, i) => {
        rul.push(this.fb.group({
            field: val.field,
            sourceType: [3, [Validators.required]],
            column: null,
            function: null,
            value: null,
            calcValue: null
          }
        ));
        this.listenDataRulesI(i);
      });
  }

  /**
   * @Metodo setValueNew
   * @description
   * */
  setValueNew(index: number) {
    this.getRulesForm().at(index).patchValue({
      column: null,
      function: null,
      value: null,
      calcValue: null
    });
  }

  /**
   * @Metodo selectDefaultsData
   * @description Para seleccionar los recursos para los Defaults
   * */
  reviewAndFilterData() {
    const val = this.form.get('rules').value;
    if (this.rules.length === val.length) {
      this.rules.forEach( ( row, i) => {
        if (row.defaults) {
          if (row.defaults.id === 1) { // Cuando es por un servicio.
            this.getAllUri(row.defaults.uri, i);
          }
          if (row.defaults.id === 2) { // Otros valores.
            // verificar en Backend tipo de valor por defecto
          }
        }
      });
    }
  }

  /**
   * @Metodo getRulesForm
   * @description Para devolver el control FormArray
   * */
  getRulesForm(): FormArray {
    return this.form.controls['rules'] as FormArray;
  }
  getRulesIs() {
    return this.form.get('rules').value;
  }

  /**
   * @Metodo selectDataForm
   * @description Para escuchar los cambios del formulario
   * */
  selectDataForm() {
    this.form.valueChanges.subscribe( val => {
      this.emitDataForm(val);
    });
  }

  /**
   * @Metodo listenDataRulesI
   * @description Para escuchar los cambios de cada campo del FormArray
   * */
  listenDataRulesI(index: number) {
    this.getRulesForm().at(index).get('sourceType').valueChanges
      .subscribe( value => {
       this.sourceTypeSelect(value, index);
        this.cancelFunction(value);
      });
  }

  /**
   * @Metodo sourceType
   * @description selecciona function column u empty
   * */
  sourceTypeSelect(sourceType, i) {
    this.statusRules(i);
    if (sourceType === 1) {this.rules[i].fx = true; };
    if (sourceType === 2) {this.rules[i].col = true;
      this.rules[i].colV = true;
    };
    if (sourceType === 4) {
      if (this.rules[i].defaults) {
        this.rules[i].defau = true;
      }else {this.rules[i].defauInput = true; }
    };
    this.setValueNew(i);
  }


  /**
   * @Metodo statusRules
   * @description pone en false rules
   * */
  statusRules(i) {
    this.rules[i].fx = false;
    this.rules[i].col = false;
    this.rules[i].valu = false;
    this.rules[i].defau = false;
    this.rules[i].defauInput = false;
    this.rules[i].icon = false;
    this.rules[i].colV = false;
  }
  /**
   * @Metodo normalizeRules
   * @description Para modificar la variable rules.
   * */
  normalizeRules(data) {
    this.rules = data;
    this.rules.forEach(
      (row, i) => {
        this.defaultsData.push({name: row.field, data: i, id: ''});
        row.fx = false;
        row.icon = false;
        row.col = false;
        row.colV = false;
        row.defau = false;
        row.calValu = false;
        row.defauInput = false;
        if (row.defaults) {
          this.defaultsData[i].id = row.defaults.value;
        }
      }
    );
  }

  /**
   * @Metodo showFunctionForm
   * @description Para form de functios
   * */
  showFunctionForm(i) {
    this.position = i;
    this.showFunctions.emit(i);
  }


  /**
   * @Metodo cancelFunction
   * @description Para cerrar el form de functions
   * */
  cancelFunction(sourceType) {
    if (sourceType !== 1 && this.position !== undefined) {
      const num = undefined;
      this.showFunctionForm(num);
    }

  }

  /**
   * @Metodo viewCalcValue
   * @description Para mostrar CalcValue
   * */
  viewCalcValue(event, i: number) {
    if (event) {
      this.rules[i].col = false;
      this.rules[i].calValu = true;
    } else {
      this.rules[i].col = true;
      this.rules[i].calValu = false;
    }
  }

  /**
   * @Metodo emitDataForm
   * @description Para emitir al form principal
   * */
  emitDataForm(val) {
    if (this.form.valid) {
      this.emitFormDefine.emit(val);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/import-template/component/define-columns/define-columns.component.ts